<script lang="ts">
  import { X } from 'lucide-svelte';
  import type { Snippet } from 'svelte';

  let {
    open = false,
    onClose,
    title,
    showCloseButton = true,
    closeOnBackdrop = false,
    closeOnEscape = true,
    headerIcon,
    children,
  }: {
    open: boolean;
    onClose: () => void;
    title?: string;
    showCloseButton?: boolean;
    closeOnBackdrop?: boolean;
    closeOnEscape?: boolean;
    headerIcon?: Snippet;
    children: Snippet;
  } = $props();

  function handleClose() {
    onClose();
  }

  function handleBackdropClick(e: MouseEvent) {
    if (closeOnBackdrop && e.target === e.currentTarget) {
      handleClose();
    }
  }

  function handleKeydown(e: KeyboardEvent) {
    if (closeOnEscape && e.key === 'Escape') {
      handleClose();
    }
  }
</script>

{#if open}
  <div
    role="dialog"
    aria-modal="true"
    tabindex="0"
    class="fixed inset-0 z-[96] flex flex-col bg-background"
    onclick={handleBackdropClick}
    onkeydown={handleKeydown}
  >
    <!-- Header with optional title and close button -->
    {#if title || showCloseButton}
      <div class="flex items-center justify-between border-b border-border p-6">
        {#if title}
          <div class="flex items-center gap-3">
            {#if headerIcon}
              {@render headerIcon()}
            {/if}
            <h2 class="text-xl font-bold text-foreground">{title}</h2>
          </div>
        {/if}

        {#if showCloseButton}
          <button
            type="button"
            onclick={handleClose}
            class="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-foreground transition-colors hover:bg-muted/80 cursor-pointer"
            aria-label="Zavřít"
          >
            <X class="h-5 w-5" />
          </button>
        {/if}
      </div>
    {/if}

    <!-- Scrollable content area -->
    <div class="flex-1 overflow-y-auto px-6 pb-24" class:pt-20={!title} class:py-6={title}>
      <div class="mx-auto max-w-md">
        {@render children()}
      </div>
    </div>
  </div>
{/if}
